import { IonContent, IonIcon, IonPage, IonText } from "@ionic/react"
import { calendar, chevronDownCircleOutline, cube, documentOutline, logoUsd, person } from "ionicons/icons"
import { useEffect, useState } from "react"
import { useHistory } from "react-router"
import service from "../../../Service/service"
import Foot from "../../Footer"
import Head from "../../Header"
import Sidebar from "../../Sidebar"

const EmployeeDashboard: React.FC = () => {
    const history = useHistory();
    const [Id] = useState(localStorage.getItem("SignupEmpId"));
    const [role] = useState(localStorage.getItem("EmpName"))
    useEffect(() => {
        if (Id === null) {
            history.push("/login");
        } else {
        }
    }, [Id, history]);

    const [emp, setEmp] = useState("");
    const [prj, setPrj] = useState("");
    const [todayabsent, settodayabsent] = useState('');
    const [pendingleave, setpendingleave] = useState('');
    const [pendingtimesheet, setpendingtimesheet] = useState('');
    const [misstimesheet, setmisstimesheet] = useState('');
    const [todaybirthday, settodaybirthday] = useState('')
    const [pendingConfirm, setpendingconfirm] = useState('');
    const [confirmdue, setconfirmdue] = useState('')

    useEffect(() => {
        Dashboardrecords();
    }, []);

    //------------------Dashboard Api----------------//

    const Dashboardrecords = () => {
        service.EmployeeDashboard(Id)
            .then((response) => {
                console.log("All Employee", response);
                if (response.status === 200) {
                   // setEmp(response.data.employeesCount)
                    setPrj(response.data.projectCount)
                    settodayabsent(response.data.todaysLeave)
                    setpendingleave(response.data.leaveBalance)
                    setpendingtimesheet(response.data.pendingTimesheetApprovals)
                    setmisstimesheet(response.data.missingTimesheets)
                    settodaybirthday(response.data.todaysBirthday)
                    setpendingconfirm(response.data.pendingConfirmation)
                    setconfirmdue(response.data.confirmDue)
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
 //---------------------Navigation------------------------//
   
    const ViewProjectdash = () => {
        history.push("./EmployeeProjectdash")
    }
    const ViewLeave = () => {
        history.push("./EmployeeLeavedash")
    }
    const ViewTimelog = () => {
        history.push("./EmployeeTimelogdash")
    }
    const ViewTimesheet = () => {
        history.push("./EmployeeTimesheetdash")
    }
    const ViewEffortdash = () => {
        history.push("./EmployeeEffortdash")
    }
    const ViewMissingTimesheet = () => {
        history.push("./EmployeeMissingTimesheetdash")
    }
    const ViewBirthday = () => {
        history.push("./EmployeesBirthday")
    }
    const ViewTimesheethistory = () => {
        history.push("./EmployeeTimesheethistorydash")
    }
    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
            <div className="page-wrapper">
                    <div className="page-header">
                        <div className="row">
                            <div className="col-sm-12">
                                <h3 className="page-title">Welcome {role} !</h3>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item active">Dashboard</li>
                                </ul>
                            </div>
                        </div>
                        <div style={{ paddingTop: '15px' }}>
                            <div className="row">
                                <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3" onClick={ViewProjectdash} >
                                    <div className="card dash-widget">
                                        <div className="card-body"style={{height: '140px',transition: 'background-color 0.3s'}}
                                            onMouseEnter={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, #fff1e1, white)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, white, white)')} >
                                            <span className="dash-widget-icon"><i className="fa fa-cubes" /></span>
                                            <div className="dash-widget-info">
                                                <br></br>
                                                <h3>{prj}</h3>
                                                <span>My Projects</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3" onClick={ViewLeave} >
                                    <div className="card dash-widget">
                                        <div className="card-body" style={{height: '140px',transition: 'background-color 0.3s'}}
                                            onMouseEnter={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, #fff1e1, white)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, white, white)')}>
                                            <span className="dash-widget-icon"><i className="fa fa-database" /></span>
                                            <div className="dash-widget-info">
                                                <br></br>
                                                <h3 style={{ color: 'white' }}>{pendingleave}</h3>
                                                <span> My Leave application</span>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}

                            </div>
                            <div className="row">
                                <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3" onClick={ViewTimelog} >
                                    <div className="card dash-widget">
                                        <div className="card-body"style={{height: '140px',transition: 'background-color 0.3s'}}
                                            onMouseEnter={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, #fff1e1, white)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, white, white)')}>
                                            <span className="dash-widget-icon"><i className="fa fa-calendar-o" /></span>
                                            <div className="dash-widget-info">
                                                <br></br>
                                                <h3 style={{ color: 'white' }}>{todayabsent}</h3>
                                                <span>My Timelog Entry</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3" onClick={ViewTimesheet}>
                                    <div className="card dash-widget">
                                        <div className="card-body"style={{height: '140px',transition: 'background-color 0.3s'}}
                                            onMouseEnter={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, #fff1e1, white)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, white, white)')}>
                                            <span className="dash-widget-icon"><i className="fa fa-list-alt" /></span>
                                            <div className="dash-widget-info">
                                                <br></br>
                                                <h3 style={{ color: 'white' }}>{0}</h3>
                                                <span>My Timesheet Generation</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3" onClick={ViewEffortdash}>
                                    <div className="card dash-widget">
                                        <div className="card-body"style={{height: '140px',transition: 'background-color 0.3s'}}
                                            onMouseEnter={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, #fff1e1, white)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, white, white)')}>
                                            <span className="dash-widget-icon"><i className="fa fa-bar-chart" /></span>
                                            <div className="dash-widget-info">
                                                <br></br>
                                                <h3>{prj}</h3>
                                                <span>My Project Effort</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3" onClick={ViewMissingTimesheet}>
                                    <div className="card dash-widget">
                                        <div className="card-body"style={{height: '140px',transition: 'background-color 0.3s'}}
                                            onMouseEnter={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, #fff1e1, white)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, white, white)')}>
                                            <span className="dash-widget-icon"><i className="fa fa-table" /></span>
                                            <div className="dash-widget-info">
                                                <br></br>
                                                <h3>{misstimesheet}</h3>
                                                <span>My Missing Timesheets</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="row">
                            <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3" onClick={ViewBirthday}>
                                <div className="card dash-widget">
                                    <div className="card-body"style={{height: '140px',transition: 'background-color 0.3s'}}
                                            onMouseEnter={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, #fff1e1, white)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, white, white)')}>
                                        <span className="dash-widget-icon"><i className="fa fa-birthday-cake" /></span>
                                        <div className="dash-widget-info">
                                            <br></br>
                                            <h3>{todaybirthday}</h3>
                                            <span>My Team Members Birthday's</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3" onClick={ViewTimesheethistory}>
                                <div className="card dash-widget">
                                    <div className="card-body"style={{height: '140px',transition: 'background-color 0.3s'}}
                                            onMouseEnter={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, #fff1e1, white)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.background = 'linear-gradient(to right, white, white)')}>
                                        <span className="dash-widget-icon"><i className="fa fa-history" /></span>
                                        <div className="dash-widget-info">
                                            <br></br>
                                            <h3 style={{ color: 'white' }}>0</h3>
                                            <span>My Timesheet History</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </IonContent>
        </IonPage>

    )

}

export default EmployeeDashboard